// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__zFlsZ","slider":"Toggle_slider__DT2MX"};